/* @flow */

import { rem } from 'polished';

import { navBarMobileHeight } from 'src/shared/app/base/component/template/style/template.style';

import { baseColor } from '@e180/ui/lib/token/color';
import {
  listReset,
  antialiasing,
} from 'src/shared/app/base/style/token/helper';
import { tablet } from '@e180/ui/lib/token/mediaQuery';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    extend: antialiasing,

    width: '100%',
    height: navBarMobileHeight,
    // Items on the edges are not always clickable on iOS with a padding of 8px
    padding: [0, 16],

    backgroundColor: baseColor,
    fill: 'currentColor',
    stroke: 'currentColor',

    fontSize: rem(12, baseFontSize),
    lineHeight: 19 / 12,

    [tablet]: {
      width: 'auto',
      height: 'auto',

      backgroundColor: 'transparent',

      fontSize: rem(16, baseFontSize),
      lineHeight: 19 / 16,
    },
  },
  'root-isHiddenOnMobile': {
    display: 'none',

    // Only small resolutions will have their nav hidden when typing
    [tablet]: {
      display: 'initial',
    },
  },
  list: {
    extend: listReset,

    display: 'flex',
    justifyContent: 'space-between',

    height: '100%',

    [tablet]: {
      flexDirection: 'column',

      height: 'auto',
    },
  },
  item: {
    position: 'relative',

    // Minimum width is required on flex child to make text ellipsis possible
    // Ref: https://css-tricks.com/flexbox-truncated-text/
    minWidth: 0,
    // Force items to not take more that a quarter of the width
    maxWidth: '25%',
    height: '100%',

    [tablet]: {
      maxWidth: 'none',
      height: 'auto',
    },
  },
  external: {
    order: -1,

    [tablet]: {
      order: 'initial',
    },
  },
  externalIcon: {
    maxWidth: 30,
    maxHeight: 30,
  },
  avatar: {
    borderRadius: '50%',
    border: ['solid', 2, 'currentColor'],
  },
  badge: {
    position: 'absolute',
    top: 12,
    left: '50%',

    pointerEvents: 'none',

    [tablet]: {
      top: 8,
      left: 18,
    },
  },
};
